import React from 'react';
import {
  setSelectedPriorityOptions,
  setSelectedSeverityOptions,
  setSelectedInterfaceOptions,
} from '@/store/slices/assetsPreviewSlice/alarmsSlice';
import { dispatch, RootState } from '@/store/store';
import { CheckboxDropdown } from '@/components/uiKit/Dropdown/CheckboxDropdown';
import { Separator } from '@/components/ui/separator';
import { useSelector } from 'react-redux';
import { useFetchAlarmsFilters } from '@/hooks/AssetsStudioPage/MainContent/Alarms/useFetchAlarmsFilters';
import { AlarmsFilter } from '@/store/api/alarmsApi';

export const toLabel = (id: string) => id.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase());

export function AlarmsFilters() {
  const { selectedPriorityOptions, selectedSeverityOptions, selectedInterfaceOptions } = useSelector(
    (state: RootState) => state.alarms
  );

  const { data } = useFetchAlarmsFilters({
    filters: [AlarmsFilter.INTERFACE, AlarmsFilter.PRIORITY, AlarmsFilter.SEVERITY],
  });

  return (
    <div className="flex items-center gap-4">
      <Separator orientation="vertical" className="h-12 w-[1px] bg-[#B1B9C3]" />
      <CheckboxDropdown
        isDisabled={!data?.priority?.length}
        groups={[
          {
            title: ' ',
            requireSelection: true,
            options:
              data?.priority?.map((id: string) => ({
                id,
                label: toLabel(id),
                checked: !!selectedPriorityOptions?.includes(id),
              })) || [],
          },
        ]}
        triggerText="Priority"
        onSelectionChange={(selectedGroups) => {
          const selected = Object.values(selectedGroups).flat();
          dispatch(setSelectedPriorityOptions(selected.map((el) => el.id)));
        }}
      />
      <CheckboxDropdown
        isDisabled={!data?.level?.length}
        groups={[
          {
            title: ' ',
            requireSelection: true,
            options:
              data?.level?.map((id: string) => ({
                id,
                label: toLabel(id),
                checked: !!selectedSeverityOptions?.includes(id),
              })) || [],
          },
        ]}
        triggerText="Severity"
        onSelectionChange={(selectedGroups) => {
          const selected = Object.values(selectedGroups).flat();
          const selectedSeverities = selected.map((el) => el.id);
          dispatch(setSelectedSeverityOptions(selectedSeverities)); // if using Redux
        }}
      />
      <CheckboxDropdown
        isDisabled={!data?.interface?.length}
        groups={[
          {
            title: ' ',
            requireSelection: true,
            options:
              data?.interface?.map((id: string) => ({
                id,
                label: toLabel(id),
                checked: !!selectedInterfaceOptions?.includes(id),
              })) || [],
          },
        ]}
        triggerText="Interface"
        onSelectionChange={(selectedGroups) => {
          const selected = Object.values(selectedGroups).flat();
          dispatch(setSelectedInterfaceOptions(selected.map((el) => el.id))); // if using Redux
        }}
      />
    </div>
  );
}
